import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    Filter,
    NumberField,
    DateField,
    BooleanField,
    ReferenceField,
    ReferenceArrayField,
    SingleFieldList,
    ChipField,
    Pagination,
} from 'react-admin';
import { getFieldsForRessource } from '../fieldsForRessource';
import utils from '../utils/utils';

const PostPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />

class CustomTableList extends React.Component {
    state = { data: null }
    myFilter = (props) => (
    <Filter {...props}>
    </Filter>
);

    ShowTitle = ({ record }) => {
        return <span>{this.props.resource.charAt(0).toUpperCase() + this.props.resource.slice(1)}</span>;
        // return <span>{this.props.resource} {record.number ? `${record.number}` : `${record.id}`}</span>;
    };

    canExport = false

    lastCheckBeforeValidate(props, data) {
        return new Promise((resolve, reject) => {
            let datagrid = null
            if (this.PostShow(props)) {
                datagrid = <Datagrid rowClick="show" expand={< this.PostShow />}>
                        {data}
                    </Datagrid>
            } else {
                datagrid = <Datagrid rowClick="show">
                        {data}
                    </Datagrid>
            }

            if (this.customActions()) {
                resolve({
                    data: <List {...this.props} sort={{ field: 'createdAt', order: 'DESC' }} bulkActionButtons={false} exporter={this.canExport} pagination={<PostPagination />} title={<this.ShowTitle />} actions={< this.customActions />}
                    filters={< this.myFilter />} filterDefaultValues={this.filterDefaultValues()}>
                        {datagrid}
                    </List>
                });
            } else {
                resolve({
                    data: <List {...this.props} sort={{ field: 'createdAt', order: 'DESC' }} bulkActionButtons={false} exporter={this.canExport} pagination={<PostPagination />} title={<this.ShowTitle />}
                    filters={< this.myFilter />} filterDefaultValues={this.filterDefaultValues()}>
                        {datagrid}
                    </List>
                });
            }
          });
    }

    customHandled(fields, fieldName, fieldList) {
        return false
    }

    componentDidMount() {
        return getFieldsForRessource(this.props.resource).then((fields) => {
        
            var fieldList = []
            for (const fieldName in fields) {
                if (!this.customHandled(fields, fieldName, fieldList)) {

                    if (fields[fieldName].type === 'String') {
                        fieldList.push(<TextField source={fieldName}/>)
                    } else if (fields[fieldName].type === 'Number') {
                        fieldList.push(<NumberField source={fieldName}/>)
                    } else if (fields[fieldName].type === 'Date') {
                        fieldList.push(<DateField source={fieldName} showTime />)
                    } else if (fields[fieldName].type === 'Boolean') {
                        fieldList.push(<BooleanField source={fieldName} />)
                    } else if (fields[fieldName].type === 'ObjectId') {
                        const plural = utils.getPlural(fields[fieldName].ref)
                        fieldList.push(<ReferenceField source={fieldName} reference={plural} link="show">
                            <TextField source={utils.displayFieldForPlural(plural)} />
                        </ReferenceField>)
                    } else if (Array.isArray(fields[fieldName].type)) {

                        if ((fields[fieldName].type[0].children)) {
                            // do nothing
                        } else {
                            var displayField = "name"
                            var ref = fieldName

                            if (fields[fieldName].type[0].type === "ObjectId") {    
                                displayField = utils.displayFieldForPlural(utils.getPlural(fields[fieldName].type[0].ref))
                                ref = utils.getPlural(fields[fieldName].type[0].ref)
                            }
        
                            fieldList.push(<ReferenceArrayField source={fieldName} reference={ref}>
                                <SingleFieldList>
                                    <ChipField source={displayField} />
                                </SingleFieldList>
                            </ReferenceArrayField>)
                        }
                    }
                }

            };

            this.lastCheckBeforeValidate(this.props, fieldList).then((data) => {
                this.setState(data);
            })
        });
    }


    render() {
    
        if (!this.state.data) {
          return <div />
        }

        return this.state.data;
    }

    PostShow(props){
        return null
    }

    customActions(props) {
        return null
    }

    filterDefaultValues(props) {
        return {};
    }
}

export default CustomTableList;
